@import 'apps/webcomponents/src/assets/scss/mixins';

:host {
  position: relative;
}

.input-error-wrapper {
  color: var(--red-layout-300-primary);
  font-size: var(--body-size);
  padding: 0 var(--spacer);

  transition: opacity 100ms ease-in-out, transform 200ms ease-out;

  pointer-events: none;
  display: block;
  opacity: 0;
  height: 0;
  transform: translateY(-10%) scaleY(0);
  transform-origin: top;

  p {
    font-family: var(--font-family-secondary);
    margin: 0;
  }
}

.visible {
  opacity: 1;
  transform: translateY(0) scaleY(1);
  margin-top: calc(var(--spacer) / 2);
  height: auto;
}

.not-visible {
  opacity: 0;
  transform: translateY(-10%) scaleY(0);
  height: 0;
}
